import axios from 'axios'
import ToktokdocLib, { User } from '@saas/lib/toktokdoc-lib/web'
import IBAN from 'iban'
import { isValidBIC } from 'ibantools'
import 'moment/locale/fr'
import moment from 'moment-timezone'
import _ from 'underscore'
import { MED_GE, MISSING_AM_NUM, WRONG_AM_NUM_LENGTH } from './constants'
// FIXME
// eslint-disable-next-line @typescript-eslint/no-var-requires

// FIXME
// eslint-disable-next-line @typescript-eslint/no-var-requires
const MobileDetect = require('mobile-detect')

export const TLC_STARTED = 'started'
export const TLC_PENDING = 'pending'

export const isChrome = () => {
    const isChromium = (window as any).chrome
    const winNav = window.navigator
    const vendorName = winNav.vendor
    const isOpera = winNav.userAgent.indexOf('OPR') > -1
    const isIEedge = winNav.userAgent.indexOf('Edge') > -1
    const isIOSChrome = winNav.userAgent.match('CriOS')

    if (isIOSChrome) {
        return true
    }
    if (
        isChromium !== null &&
        typeof isChromium !== 'undefined' &&
        vendorName === 'Google Inc.' &&
        isOpera === false &&
        isIEedge === false
    ) {
        return true
    }
    return false
}

export const isSafari = () => {
    let value = false
    const ua = navigator.userAgent.toLowerCase()
    if (ua.indexOf('safari') !== -1) {
        let detectableTermsInUa = ['crios', 'chrome']
        detectableTermsInUa = detectableTermsInUa.filter((term) => ua.indexOf(term) > -1)
        if (detectableTermsInUa.length > 0) {
            value = false
        } else {
            value = true
        }
    }
    return value
}

export const isFirefox = () => {
    let value = false
    const ua = navigator.userAgent.toLowerCase()
    if (ua.indexOf('firefox') !== -1) {
        if (ua.indexOf('chrome') < 0) value = true
    }
    return value
}

export const isiOS = () => {
    const md = new MobileDetect(navigator.userAgent)
    const res = md.os() === 'iOS'
    return res
}
export const isAndroid = () => {
    const ua = navigator.userAgent.toLowerCase()
    return ua.indexOf('android') > -1
}

export const isMobileOrTabletBrowser = () => {
    const md = new MobileDetect(navigator.userAgent)
    const isNewIpad =
        window.navigator.userAgent.match(/Mac/) &&
        window.navigator.maxTouchPoints &&
        window.navigator.maxTouchPoints > 2
    const isIpad = navigator.platform.match(/iPad/i)
    const res = !!md.mobile() || !!md.phone() || !!md.tablet() || !!isNewIpad || !!isIpad
    return res
}

export const isIOsMobileDeviceAndNotSafariBrowser = () => {
    let result = 'safari'
    const isIOsDevice = isiOS()

    if (isMobileOrTabletBrowser()) {
        if (isIOsDevice) {
            result = isSafari() ? 'safari' : 'not-safari'
        }
    }
    return result
}

export const isAndroidDeviceAndChromeBrowser = () => isMobileOrTabletBrowser() && isAndroid() && isChrome()

export const isMobileBrowser = () => {
    const md = new MobileDetect(navigator.userAgent)
    const res = !!md.mobile()
    return res
}

export const isPhoneBrowser = () => {
    const md = new MobileDetect(navigator.userAgent)
    const res = !!md.phone()
    return res
}

export const removeFixSafariMobileCursorBug = () => {
    if (isSafari()) document.body.style.position = ''
}

export const findUsersByRpps = async (nationalId: any) => {
    try {
        const token = await ToktokdocLib.Utils.getSessionToken()
        const res = await axios.get(`${window._env_.REACT_APP_HDS_HOST}/user/national_id/${nationalId}`, {
            headers: {
                'X-Session-Token': token,
            },
        })

        return res.data
    } catch (e) {
        return false
    }
}

export const getNationalIdFromHealthSystemInfo = (extraHealthSystemInfo: any, user?: any) => {
    const fromExtra =
        extraHealthSystemInfo?.rppsNum ??
        extraHealthSystemInfo?.adeliNum ??
        extraHealthSystemInfo?.nationalId ??
        extraHealthSystemInfo?.rpps

    const rawNationalId = fromExtra ?? user?.rppsNum ?? user?.nationalId ?? ''
    return String(rawNationalId).trim()
}

/**
 *
 *
 * @param {*} rppsNum
 * @param {*} user
 * @returns
 */
export const isRppsNumOrAdeliNumValid = (nationalId: any, userId: any) => {
    const str = String(nationalId)
    // find all users that bear this rpps except the current one
    return findUsersByRpps(nationalId).then((user) => {
        if (nationalId && str.length !== 0) {
            if (/^(?:[A-Za-z0-9]{9}|[0-9]{11})$/.test(str)) {
                if (user && user !== userId) {
                    return 'Numéro RPPS ou ADELI déjà utilisé'
                }
            } else {
                return "L'identifiant national doit contenir 9 ou 11 caractères."
            }
        } else {
            return 'Un numéro RPPS ou ADELI doit être fourni'
        }
        return undefined
    })
}

export const isAmNumValid = (amNum: unknown, isEmployee: boolean): string => {
    const str = String(amNum ?? '').trim()
    const regex = /^(?:\d{9}|\d{15}|\d{16}|\d{17})$/

    // For employees AM num is not required
    if (isEmployee && !str) return ''

    // For non-employees AM num is mandatory
    if (!isEmployee && !str) return MISSING_AM_NUM

    // AM num does not match the valid format
    if (!regex.test(str)) return WRONG_AM_NUM_LENGTH

    // AM num is valid
    return ''
}

export const isPrivatePhoneValid = (privatePhone: any) => {
    if (privatePhone !== undefined && privatePhone !== null && privatePhone.length !== 0) {
        const cleanedPrivatePhone = privatePhone.replace(/ /g, '')
        if (/^(0|(00|\+)33)[67][0-9]{8}$/.test(cleanedPrivatePhone)) {
            return ''
        }
        if (/^(0|(00|\+)33)[1234589][0-9]{8}$/.test(cleanedPrivatePhone)) {
            return 'Un numéro de téléphone portable doit être fourni'
        }
        return 'Format non valide'
    }
    return `Votre numéro de téléphone mobile est obligatoire, cliquez sur le bouton "modifier" pour être redirigé vers l'interface dédiée`
}

export const isContactPhoneValid = (contactPhone: any) => {
    if (contactPhone !== undefined && contactPhone !== null && contactPhone.length !== 0) {
        const cleanedContactPhone = contactPhone.replace(/ /g, '')
        if (
            /^(0|(00|\+)33)[1234589][0-9]{8}$/.test(cleanedContactPhone) ||
            /^(0|(00|\+)33)[67][0-9]{8}$/.test(cleanedContactPhone)
        ) {
            return ''
        }
        return 'Format non valide'
    }
    return 'Votre numéro de téléphone professionnel est obligatoire et n’a pas été renseigné'
}

export const isPostalCodeValid = (postalCode: any) => {
    if (!postalCode || (postalCode && postalCode.length === 0)) {
        return 'Le CP doit être fourni'
    }
    if (/\D/.test(postalCode)) {
        return 'Caractère alphabétique impossible'
    }
    if (postalCode.length === 5) {
        return ''
    }
    return 'Le CP doit contenir 5 chiffres'
}

export const isIbanValid = (pIban: any) => {
    if (pIban) {
        const isValid = IBAN.isValid(pIban)
        if (isValid) {
            return ''
        }
        return 'Le numéro IBAN est non valide'
    }
    return ''
}

export const isBicValid = (pBic: any) => {
    if (pBic) {
        const isValid = isValidBIC(pBic)
        if (isValid) {
            return ''
        }
        return 'Le BIC est non valide'
    }
    return ''
}

export const isEmployedSocNameValid = (employedSocName: string) => {
    if (!employedSocName || (employedSocName && employedSocName.length === 0)) {
        return 'Le nom de la structure doit être fourni'
    }
    return ''
}

export const formatDate = (date: any) => moment(date.iso).format('DD/MM/YYYY')

export /**
 * checks if the user's last CGU version checked
 * and the current CGU version are equal
 * @param {*} technicalConfig the current user's technical config
 *  * @param {*} globalConfig the globalConfig object
 * @returns true if current cgu and last checked cgu match
 */
const hasAgreedToCurrentCGU = (technicalConfig: any, globalConfig: any) => {
    if (!(technicalConfig && globalConfig)) return false
    // get the global config
    const currentGlobalConfig = globalConfig
    // get the current CGU version
    const { currentCGUVersion } = currentGlobalConfig
    // get the last CGU version checked by the user
    const { lastCGUVersionChecked } = technicalConfig
    // return their boolean matching value
    return currentCGUVersion === lastCGUVersionChecked
}

export /**
 *
 *
 * @param {*} user
 *
 * @returns
 */
const hasSeenLastFeatureReleaseNote = async (user: any) => {
    const parseUser = await User.findOne(user.objectId)
    const notif = await parseUser.isNotificationNeeded('RequiredExpert')
    return notif
}

export const checkIfUserHasAllMandatoryInfosProfile = async (
    user: any,
    address: any,
    extraHealthSystemInfo: any,
    extraHealthActivityInfo: any,
    checkSign = false,
) => {
    if (
        user === undefined ||
        user === null ||
        address === undefined ||
        address === null ||
        extraHealthSystemInfo === undefined ||
        extraHealthSystemInfo === null ||
        extraHealthActivityInfo === undefined ||
        extraHealthActivityInfo === null
    ) {
        console.error(
            'checkIfUserHasAllMandatoryInfosProfile : user or address or extraHealthSystemInfo or extraHealthActivityInfo missing',
        )
        return false
    }

    if (checkSign) {
        if (!extraHealthSystemInfo.signature) {
            console.error('checkIfUserHasAllMandatoryInfosProfile : signature missing')
            return false
        }
    }
    const nationalId = getNationalIdFromHealthSystemInfo(extraHealthSystemInfo, user)
    const rppsError = await isRppsNumOrAdeliNumValid(nationalId, user.objectId)
    if (rppsError !== undefined) {
        console.log(`checkIfUserHasAllMandatoryInfosProfile : rppsNum missing | reason : ${rppsError} `)
        return false
    }

    if (!(user.firstName && user.firstName !== '')) {
        console.log('checkIfUserHasAllMandatoryInfosProfile : firstName missing')
        return false
    }

    if (!(user.lastName && user.lastName !== '')) {
        console.log('checkIfUserHasAllMandatoryInfosProfile : lastName missing')
        return false
    }

    if (isPrivatePhoneValid(user.privatePhone) !== '') {
        console.log('checkIfUserHasAllMandatoryInfosProfile : privatePhone missing')
        return false
    }

    if (isContactPhoneValid(user.contactPhone) !== '') {
        console.log('checkIfUserHasAllMandatoryInfosProfile : contactPhone missing')
        return false
    }

    if (!address.street) {
        console.log('checkIfUserHasAllMandatoryInfosProfile : street missing')
        return false
    }

    if (isPostalCodeValid(address.postalCode) !== '') {
        console.log('checkIfUserHasAllMandatoryInfosProfile : postalCode missing')
        return false
    }

    if (!address.city) {
        console.log('checkIfUserHasAllMandatoryInfosProfile : city missing')
        return false
    }

    if (isAmNumValid(extraHealthSystemInfo.amNum, extraHealthSystemInfo.isEmployee) !== '') {
        console.log('checkIfUserHasAllMandatoryInfosProfile : amNum missing')
        console.log('amNm : ', extraHealthSystemInfo.amNum)
        return false
    }

    if (
        (extraHealthSystemInfo.isSectorOne === undefined || extraHealthSystemInfo.isSectorOne === null) &&
        extraHealthSystemInfo.isEmployee === false
    ) {
        console.log('checkIfUserHasAllMandatoryInfosProfile : isSectorOne missing')
        return false
    }

    if (
        (extraHealthSystemInfo.isOptam === undefined || extraHealthSystemInfo.isOptam === null) &&
        extraHealthSystemInfo.isEmployee === false
    ) {
        console.log('checkIfUserHasAllMandatoryInfosProfile : isOptam missing')
        return false
    }

    if (extraHealthActivityInfo.qualification === undefined || extraHealthActivityInfo.qualification === null) {
        console.log('checkIfUserHasAllMandatoryInfosProfile : qualification missing')
        return false
    }

    if (extraHealthActivityInfo.profession.length === 0) {
        console.log('checkIfUserHasAllMandatoryInfosProfile : profession missing')
        return false
    }
    if (extraHealthActivityInfo.profession[0].isSpeMandatory && !extraHealthActivityInfo.speciality) {
        console.log('checkIfUserHasAllMandatoryInfosProfile : speciality missing')
        return false
    }

    return true
}

export const getPriceObjtArrFromRawList = (pPricesArr: any) => {
    const resList: any = []
    pPricesArr.forEach((aPriceElem: any) => {
        const priceArr = aPriceElem.split('-')
        const curPInfos = {
            price: Number(priceArr[0]),
            careCode: priceArr[1],
            careLib: priceArr[2],
        }
        resList.push(curPInfos)
    })

    return resList
}

// THIS NOT CLEAN NEEDS ENHANCEMENTS
export const getMedGeIdForSelectList = (pDocSpeList: any) => {
    let res = {}
    _.forEach(pDocSpeList, (aSpe: any, key: any) => {
        if (aSpe.name === MED_GE) {
            res = {
                uid: key,
                name: aSpe.name,
            }
        }
    })
    return res
}

export const pageview = (pCategory: any, pName: any) => {
    // FIXME
    // eslint-disable-next-line no-underscore-dangle
    if ((window as any)._paq) {
        // FIXME
        // eslint-disable-next-line no-underscore-dangle
        if ((window as any)._paq) (window as any)._paq.push(['trackEvent', pCategory, pName])
    }
}

export const isEmailValid = (pEmail: any) => {
    if (typeof pEmail === 'undefined') {
        return ''
    }
    if (pEmail.length !== 0) {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]{2,3}$/
        if (re.test(pEmail)) {
            return ''
        }
        return 'E-mail incorrect'
    }
    return ''
}

export const formatPrice = (price: any) =>
    new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR',
    }).format(price)

/**
 * @description capitalize first letter of a string
 * @param {string} s
 * @returns {string} capitalized string
 */
export const ucfirst = (s: string) => {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
}

/**
 * @description capitalize text
 * @param {string} text
 * @returns {string} capitalized string
 */
export const capitalize = (text: any) => {
    if (text) {
        const raw = text.toLowerCase().split(' ')
        const result = raw.map((r: any) => ucfirst(r))
        return result.join(' ')
    }
    return ''
}

export const formatPDFTitle = (title: any, carac: any) => title.substr(title.indexOf(carac) + 1)

export const windowBreakpoints = {
    SMALL_SCREEN: 960,
    LARGE_SCREEN: 1280,
}

export const customEventsManager = {
    triggerEvent: (event: any, data: any) => {
        const target = window

        if (!data) {
            data = {}
        }
        if (!event) {
            console.error('ERROR: Missing arguments event')
            return
        }
        const evt = new CustomEvent(event, {
            detail: data,
        })
        target.dispatchEvent(evt)
    },

    subscribe: (event: any, callback: any) => {
        const target = window

        if (!event || !callback) {
            console.error('ERROR: Missing arguments event || callback')
            return
        }

        function triggerCallback(e: any) {
            callback(e)
        }

        target.removeEventListener(event, triggerCallback)
        target.addEventListener(event, triggerCallback)
    },
}

/**
 * @description extract raw text from the editor
 * @param {String} draftJs string to convert
 * @returns {String} raw text
 */
export const extractRawTextDraftJs = (draftJs: any) => {
    try {
        const parsed = JSON.parse(draftJs)
        if (!parsed || !parsed.blocks) return ''
        return parsed.blocks
            .map((block: any) => (block.text || '').trim())
            .join('')
            .trim()
    } catch (e) {
        return ''
    }
}

export const generateRandomGuiID = (length?: any) => {
    if (!length) length = 12
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

    let result = ''

    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * characters.length))
    }

    return result
}

/**
 * @description compare consultation appointment date
 * @param {Date} a
 * @param {Date} b
 * @returns {number}
 */
export const compareAppointmentDate = (a: any, b: any) => {
    const date1 = moment(a.appointmentDate)
    const date2 = moment(b.appointmentDate)

    if (date1.isBefore(date2)) {
        return -1
    }
    return 1
}

export const hexToRgba = (hex: string, opacity = 1) => {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)

    const rgb = {
        // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
        r: parseInt(result[1], 16),
        // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
        g: parseInt(result[2], 16),
        // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
        b: parseInt(result[3], 16),
    }
    return `rgba(${rgb.r},${rgb.g},${rgb.b}, ${opacity})`
}

/**
 *
 * @param {String} fileUrl the url of required file to download
 * @param {String} fileName the name of the downloaded file
 */
export const appendAndTriggerPdfDownloadLink = (fileUrl: string, fileName: string) => {
    if (fileUrl && fileName) {
        const a = document.createElement('A')
        a.setAttribute('href', fileUrl)
        a.setAttribute('download', fileName)
        document.body.appendChild(a)
        a.click()
        a.remove()
    }
}

/**
 *
 * @param {Function} callback
 * @returns
 */
export const isCallback = (callback: any) => callback && typeof callback === 'function'

export const checkisDescendant = (parent: HTMLElement, child: HTMLElement) => {
    let node = child.parentNode
    while (node !== null) {
        if (node === parent) {
            return true
        }
        node = node.parentNode
    }
    return false
}

const STANDARD_PPC_WORKFLOW_NAME = 'renouvellement ppc standard'

/**
 * @description whether a workflow is the standard PPC renewal: its name contains "Renouvellement PPC standard",
 * whatever the case and the words around it
 * @param {string | null | undefined} workflowName
 * @returns {boolean}
 */
export const isStandardPpcWorkflow = (workflowName?: string | null): boolean =>
    !!workflowName?.toLowerCase().includes(STANDARD_PPC_WORKFLOW_NAME)
